import React from "react";
import { useNavigate, useLocation } from "react-router-dom"; // Import useNavigate hook
import check from "../src/assests/check.svg";

const DisclaimerWarning = () => {
  const location = useLocation();
  const cardType  = location.state.type;
  const navigate = useNavigate(); // Initialize the useNavigate hook
  
  const goToCreateYourCard = () => {
    navigate("/select-country", { state: { type: cardType } });
  };

  const ConfirmButton = () => (
    <button
      className={`w-full ${cardType === 'gift' ? "green-btn" : "pink-btn"}`}
      onClick={goToCreateYourCard}
    >
      <span className="text-white flex justify-center items-center">
        <img src={check} alt="check" height="12" width="12"/>
        <span className="ps-3">Confirm</span>
      </span>
    </button>
  );

  return (
    <div className="absolute bg-nav-bar flex justify-center items-center mx-8 sm:mx-0 rounded-lg gray-border overflow-y-auto sm:w-full lg:w-880">
      <div className="text-white w-full">
        <div className="flex flex-col items-center">
          {/* heading */}
          <div className="flex items-center justify-start p-4">
            <h2 className="text-2xl font-bold mb-3">
              Welcome to PayPaw!
            </h2>
          </div>
          {/* body */}
          <div className="flex flex-col items-center px-4">
            <div className="pb-24 md:pb-4"> {/* Reduced padding for desktop */}
              <p>
                <span className="flex items-center justify-center">⚠️ Disclaimer for Prepaid Cards ⚠️</span>
                <br/>
                - Card Types: We offer Mastercard (MyPrepaidCenter) in USD (US ONLY) VISA Rewards (US ONLY) and Mastercard (Obsidian) [NOT MOBILE WALLET COMPATIBLE] in USD (Global). <strong>US-ONLY cards are STRICTLY for United States of America. They can only be redeemed and used within US Territory.</strong>
                <br/>
                <br/>
                - Acceptance:
                <br/>
                &emsp;- USD Mastercard (MyPrepaidCenter) and Mastercard (Obsidian) work almost everywhere,  OBSIDIAN IS NOT WALLET COMPATIBLE, but works online, MyPrepaidCenter MPC is compatible with Apple/Google/Samsung wallets, and work online as well.
                <br/>
                <br/>
                &emsp;- Delivery Time: Receiving your prepaid card may take up to 1 hour. However, it is usually delivered within 15 minutes.
                <br/>
                <br/>
                Email is only used to provide you with a copy of your purchase. A valid email must be provided.
                <br/>
                <br/>
                By proceeding, you acknowledge and accept the following terms:
                <br/>
                <br/>
                - Attempting to redeem from a Restricted Country will void your refund. This includes buying a US Only card from outside the US.
                <br/>
                <br/>
                - The activation link is valid for 60 days from the date it is generated.
                <br/>
                <br/>
                - VPNs or proxies are not permitted by the provider.
                <br/>
                <br/>
                - If you lose access to the email address you provided, your card will be lost.
                <br/>
              </p>
            </div>
            
            {/* Desktop button (hidden on mobile) */}
            <div className="hidden md:block pb-4">
              <ConfirmButton />
            </div>
            
            {/* Mobile fixed button (hidden on desktop) */}
            <div className="fixed bottom-0 left-0 right-0 p-4 bg-nav-bar border-t border-gray-700 md:hidden">
              <ConfirmButton />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DisclaimerWarning;







